import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accountreports',
  templateUrl: './accountreports.component.html',
  styleUrls: ['./accountreports.component.css']
})
export class AccountreportsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
